import Request from '@/api/request';

export interface IDistrict {
  rid: string,
  districtId: string,
  chamberId: string,
  regionCode: string,
  regionName: string,
  name: string
}

interface GetDistrictsPayload {
  regionCode: string;
}

const api = new Request('lk/');

export function getDistricts(region: GetDistrictsPayload): Promise<IDistrict[]> {
  return api.post('getDistricts', region)
}
